import { FieldType } from '../../../types/Field.type';
import { ProductChannelRef } from '../../enm/ProductChannel';
export const ProductChannel = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.product_channel.label',
    fallbackLabel: 'How do you plan to do your sales?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => true,
    type: FieldType.Enum,
    options: ProductChannelRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return false;
}
